<template>
  <div>
    <p class="heading-st1">Welcome to the CyberGeeks guild website! Either your here because your looking for a guild, part of our guild, or scooping out the competition. If any of these are true feel free to look around, the ComputerizedSmartAlecs won't stop you.</p>
  </div>
</template>

<script>
export default {
  name: 'Description'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.heading-st1{
   display: flex;
  font-family:Archia ;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.5rem;
  text-align: center;
  padding-left: 4rem;
  padding-top: 2rem;
  padding-bottom: 4rem;
  padding-right: 4rem;
  color: #FFFFFF;
}

.discord-logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 250px;
}

.blue-button {
  background-color: #7289da;
  border: 2px solid #7289da;
  color: #fff;
  display: inline-block;
  font-family: Whitney, "Open Sans", Helvetica, sans-serif;
  font-weight: 400;
  font-size: 11pt;
  border-radius: 3px;
  cursor: pointer;
  height: 45px;
  width: 250px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
}
.heading-st2{
  font-family: Shrimp;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 2.0rem;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #FFFFFF;
  color: black;
}
</style>